import { omit } from 'lodash'
import type { FormResponseCorvid } from '../types/types'
import type { FormResponse } from '@wix/ambassador-wix-events-web-http/types'

export const removeNumberPropFromInputs = ({ inputValues = [] }: FormResponse): FormResponseCorvid => ({
	inputValues: inputValues.map((inputObj) => omit(inputObj, ['number'])),
})
